import React from 'react';

import { icons } from '@ublend-npm/aulaui-next';
import { Element } from 'slate';
import { AulaPlugin } from '../plugins';
import { FileBlock } from '../../components/File/File';
import { fileBlockType, isFileElement } from './fileBlockType';
import {
  DefaultMenuItem,
  NestedMenuItem,
} from '../../components/NestedMenu/NestedMenu';

/**
 * file plugin
 */
export const file: AulaPlugin = (editableProps, editor, context) => {
  const { isVoid } = editor;

  if (context == null) {
    throw new Error('context needs to be initialized');
  }

  // plugins can be used to override/extend editor methods such as isVoid or normalizeNode
  editor.isVoid = (element: Element) =>
    element.type === fileBlockType ? true : isVoid(element);

  return {
    ...editableProps,
    blockMenu: {
      ...editableProps.blockMenu,
      File: {
        ...editableProps?.blockMenu?.File,
        'My Computer': ({ text, attributes, openFileDialog }) => (
          <NestedMenuItem
            text={text}
            key={text}
            attributes={{
              ...attributes,
              onClick: openFileDialog,
            }}
            leftIcon={<icons.Computer />}
          />
        ),
      },
    },
    renderSubMenuItem: ({ text, attributes, children, onClose, element }) =>
      text === 'File' ? (
        <NestedMenuItem
          leftIcon={<icons.AttachFileIcon />}
          text={text}
          key={text}
          rightIcon={<icons.ArrowRight />}
          onClose={onClose}
          attributes={attributes}
        >
          {children}
        </NestedMenuItem>
      ) : (
        <DefaultMenuItem
          element={element}
          onClose={onClose}
          text={text}
          attributes={attributes}
        >
          {children}
        </DefaultMenuItem>
      ),
    renderElement: (props) => {
      const { children, element, attributes } = props;

      if (isFileElement(element)) {
        return (
          <div {...attributes}>
            <div contentEditable={false}>
              <FileBlock element={element} />
            </div>
            {children}
          </div>
        );
      }

      return editableProps.renderElement?.(props) || <p />;
    },
  };
};
